<template>
    <b-container fluid>
        <b-row>
            <b-col cols="2">
                <b-button
                    :to="{name: 'reports'}"
                    variant="tetradic-3"
                    size="sm"
                    @click.stop="resetState"
                >
                    <fa-icon :icon="['fal','chevron-circle-left']" />
                    Back To Reports
                </b-button>
            </b-col>
            <b-col class="text-left">
                <h3><slot name="title" /></h3>
            </b-col>
        </b-row>
        <hr>

        <slot name="default" />
    </b-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'ReportWrapper',

    metaInfo() {
        return { title: 'ReportWrapper' };
    },

    data() {
        return {
        };
    },
    methods: {
        ...mapActions({
            resetReportState: 'reports/resetReportState',
        }),
        resetState(item) {
            this.resetReportState();
        },
    },
};
</script>

<style scoped lang="scss">
</style>
